module.exports = __webpack_public_path__ + "static/media/4.cfe05b4f.jpg";